var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00006a",
    d: "M.004 0h640v480h-640z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .002l318.986 304.34h65.432L72.318.145 0 .002z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.515 304.324L48.2-.003 23.894.37l313.623 303.96h22.997z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.424.002L65.437 304.342H.005L312.105.145l72.319-.144z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.447.003L48.253 304.33l-24.296.012L337.457.003h22.989z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M161.455.004h61.505v304.332h-61.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.005 121.736h384.403v60.866H.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M174.915.004h34.597v304.332h-34.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M.005 136.959h384.403v30.433H.005z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M520.008 179.327l-19.577-14.469-20.296 13.424 7.642-23.186-18.972-15.257 24.295.139 8.567-22.854 7.384 23.27 24.26 1.134-19.728 14.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M512.157 167.613l-11.58-8.375-11.837 8.007 4.35-13.66-11.237-8.844 14.273-.067 4.893-13.472 4.469 13.62 14.254.516-11.494 8.485z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M444.878 304.045L425.3 289.576 405.004 303l7.643-23.186-18.973-15.257 24.296.139 8.566-22.854 7.385 23.271 24.26 1.133-19.728 14.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M437.026 292.331l-11.58-8.375-11.836 8.007 4.35-13.66-11.238-8.843 14.274-.068 4.892-13.472 4.47 13.62 14.254.516-11.494 8.485z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M598.633 291.753l-19.576-14.469-20.297 13.424 7.642-23.186-18.972-15.256 24.295.138 8.567-22.853 7.384 23.27 24.26 1.133-19.727 14.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M590.782 280.04l-11.58-8.376-11.836 8.007 4.35-13.66-11.238-8.843 14.274-.067 4.892-13.472 4.469 13.619 14.254.516-11.494 8.486z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M518.261 469.17l-19.577-14.468-20.296 13.423 7.642-23.185-18.973-15.257 24.296.138 8.566-22.853 7.385 23.27 24.26 1.134-19.728 14.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M510.41 457.457l-11.581-8.375-11.836 8.007 4.35-13.66-11.238-8.844 14.274-.067 4.893-13.472 4.468 13.62 14.255.516-11.494 8.485z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/nz.bdb5baa687d43232a69c56db0f1fc075.svg";
export { ForwardRef as ReactComponent };